import React, { useState, useEffect } from 'react';
import { useTheme } from "./ThemeContext";
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const { darkMode, toggleDarkMode } = useTheme();
  const location = useLocation();

  const tabs = [
    { id: 'home', label: 'Home', route: '/' },
    { id: 'images', label: 'Images', route: '/imagetools' }, 
    // { id: 'pdf', label: 'PDF', route: '/pdftools' },
    { id: 'text', label: 'Text', route: '/texttools' },
    { id: 'colors', label: 'Colors', route: '/colortools' }
  ];

  const [activeTab, setActiveTab] = useState('home');

  useEffect(() => {
    const currentTab = tabs.find(tab => tab.route === location.pathname)?.id || 'home';
    setActiveTab(currentTab);
  }, [location.pathname]); 

  return (
    <>
      {/* Header Section */}
      <header className={`backdrop-blur-md ${darkMode ? 'bg-gray-900/80' : 'bg-white/80'} sticky top-0 z-10 shadow-sm`}>
        <div className="container mx-auto p-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-500 to-indigo-600 bg-clip-text text-transparent">
          WebUtility
          </h1>

          {/* Right-side Controls */}
          <div className="flex items-center space-x-4">
            <div className={`relative rounded-full ${darkMode ? 'bg-gray-800' : 'bg-gray-100'} px-4 py-2`}>
              <input
                type="text"
                placeholder="Search tools..."
                className={`${darkMode ? 'bg-gray-800 text-white' : 'bg-gray-100 text-gray-800'} outline-none`}
              />
              <span className="absolute right-3 top-2">🔍</span>
            </div>

            {/* <button
              onClick={toggleDarkMode} 
              className={`p-2 rounded-full ${darkMode ? 'bg-gray-800' : 'bg-gray-100'}`}
            >
              {darkMode ? '☀️' : '🌙'}
            </button> */}
          </div>
        </div>
      </header>

      {/* Navigation Tabs */}
      <nav className={`${darkMode ? 'bg-gray-800' : 'bg-white'} shadow-sm mb-6`}>
        <div className="container mx-auto">
          <div className="flex overflow-x-auto scrollbar-hide">
            {tabs.map(tab => (
              <Link
                to={tab.route}
                key={tab.id}
                className={`px-6 py-4 font-medium transition-colors ${
                  activeTab === tab.id
                    ? `border-b-2 border-blue-500 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`
                    : `${darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-600 hover:text-gray-800'}`
                }`}
              >
                {tab.label}
              </Link>
            ))}
          </div>
        </div>
      </nav>
    </>
  );
}
